/** @type {Intl.DateTimeFormatOptions} - Date Time Format Options of Date class */
export let dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
};
